/**
 * Custom cache expiry times for specific queries (in milliseconds)
 * If not specified, defaults to MAX_CACHE_AGE (24 hours)
 */
export const QUERY_CACHE_EXPIRY: Record<string, number> = {
  "avatarLibrary.list": 30 * 1000, // 30 seconds
  "avatar.apiListAvatarVoiceMappings": 60 * 60 * 1000, // 60 minutes
  // Add more custom expiry times here:
  // "video.list": 5 * 60 * 1000, // 5 minutes
  // "users.getUserWithTeam": 10 * 60 * 1000, // 10 minutes
}

/**
 * Query keys that should NEVER be persisted (BLACKLIST)
 *
 * Only add queries here that must ALWAYS be fresh:
 * - Authentication/session data (security risk)
 * - Real-time status/progress data (stale data useless)
 * - Payment/billing information (security + must be current)
 * - API keys or secrets (security risk)
 *
 * Everything else will be cached automatically!
 */
export const SKIP_PERSIST_KEYS = [
  // Authentication & Session (security)
  "auth.getSession",
  "auth",
  "session",
  "getSession",
  "verifyToken",

  // AssetJob - All job-related queries need fresh/real-time data
  "assetJob.getJobStatus",
  "assetJob.getJobsByIds",
  "assetJob.getJobsForVideo",
  "assetJob.getJobById",

  // API Keys & Secrets (security)
  // "apiKey",
  // "getCurrentApiKey",

  // // Payment & Billing (security + freshness)
  // "payment",
  // "billing",
  // "subscription",
  // "invoice",
  // "checkout",

  // // Real-time Status & Progress (freshness required)
  // "getGenerationStatus",
  // "getJobStatus",
  // "video.getGenerationStatus",
  // "pollStatus",
  // "status",

  // // Webhooks & External Events (must be fresh)
  // "webhook",

  // Credits & Usage (financial data - must always be fresh)
  "users.getUserWithTeam",
] as const

/**
 * Cache version - automatically invalidates on each deploy via git hash
 * In development: Uses manual version (v2-dev)
 * In production: Uses git commit hash (v2-abc123)
 *
 * The git commit hash is injected at build time by vite-plugin-git-revision
 */
export const CACHE_VERSION =
  import.meta.env.MODE === "production"
    ? `v2-${import.meta.env.VITE_COMMITHASH?.substring(0, 8) || "unknown"}`
    : "v2-dev"

/**
 * Maximum age for persisted queries (180 seconds / 3 minutes in milliseconds)
 * After this time, cached data is considered stale and will be removed
 */
export const MAX_CACHE_AGE = 180 * 1000 // 180 seconds (3 minutes)
